import { getPitchName } from './pitch-names'

export default function getShortPitchName(type, numPitches) {
    if (numPitches > 6) {
        return type.toUpperCase()
    }
    switch (type.toLowerCase()) {
        case 'ff':
            return '4-Seam'
        case 'cu':
            return 'Curve'
        case 'fs':
            return 'Split'
        case 'ch':
            return 'Change'
        case 'kn':
            return 'Knuckle'
        default:
            return getPitchName(type)
    }
}
